import{useState as o}from"react";const s=()=>{const[e,t]=o(!1);return{focus:e,handleFocus:()=>{t(!e)}}};export{s as useTextFieldMultiline};
